var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54205 2.00391C9.21613 2.08897 10.5479 3.47373 10.5479 5.16895L10.543 5.33203C10.4779 6.61392 9.64981 7.69168 8.50494 8.12793C10.9789 8.2466 12.9483 10.2906 12.9483 12.7939C12.9483 13.9338 12.0246 14.8582 10.8848 14.8584H3.87311C2.73318 14.8584 1.80869 13.9339 1.80865 12.7939C1.80869 10.2903 3.77858 8.24608 6.25299 8.12793C5.10749 7.69213 4.27902 6.61427 4.21393 5.33203L4.21002 5.16895C4.21002 3.41891 5.62893 2 7.37897 2L7.54205 2.00391ZM6.47955 9.12305C4.45223 9.12305 2.80869 10.7666 2.80865 12.7939C2.80869 13.3816 3.28546 13.8584 3.87311 13.8584H10.8848C11.4723 13.8582 11.9483 13.3815 11.9483 12.7939C11.9483 10.7666 10.3047 9.12306 8.2774 9.12305H6.47955ZM7.37897 3C6.18121 3 5.21002 3.97119 5.21002 5.16895C5.21014 6.3666 6.18129 7.33789 7.37897 7.33789C8.57647 7.33769 9.54779 6.36647 9.54791 5.16895C9.54791 3.97132 8.57655 3.0002 7.37897 3Z",
    fill: "#025F4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9695 12.2337V11.2298C14.9695 9.44602 13.5235 8 11.7397 8V8H11.1667",
    stroke: "#025F4C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1666 7.99967C12.427 7.99967 13.6002 6.87553 13.6002 5.61514C13.6002 4.35476 12.5784 3.33301 11.318 3.33301",
    stroke: "#025F4C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.5513053558fec1560852e1923ca5546c.svg";
export { ForwardRef as ReactComponent };